/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Required_Delete_PatternsInputs */



/**
* | output |
* | --- |
* | "Compliance must be enabled to delete patterns." |
*
* @param {Compliance_Required_Delete_PatternsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_required_delete_patterns = /** @type {((inputs?: Compliance_Required_Delete_PatternsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Required_Delete_PatternsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Compliance muss aktiviert sein, um Muster zu löschen.")
	return /** @type {LocalizedString} */ ("Compliance must be enabled to delete patterns.")
});